// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_MigrarColaboradoresInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /migration/colaboradores/migrar-todas
 * (controllers/migration/colaboradores.php::migrar_todas).
 *
 * Um unico campo, OPCIONAL: o ESCOPO da carga.
 *
 * ---------------------------------------------------------------------------
 * POR QUE A CARGA E POR FRANQUIA
 * ---------------------------------------------------------------------------
 * Sao ~231 colaboradores x ~3 chamadas ao Cognito, mais os toggles de franquia
 * do staff (26 pessoas com ate 70 franquias cada), TUDO dentro da requisicao
 * HTTP do operador — nao ha fila nem worker, e o bearer que autoriza as chamadas
 * de admin vem do header da requisicao corrente. Sem recorte, a carga inteira
 * disputa com o timeout do nginx/PHP-FPM e com a validade do token.
 *
 * A funcao Deluge da origem ja aceita `id_unidade`, entao o recorte e barato e
 * nativo: migrar franquia a franquia cabe com folga, e o operador ve o
 * resultado de cada uma antes de seguir.
 *
 * ---------------------------------------------------------------------------
 * "TODAS" SE PEDE OMITINDO O CAMPO — nunca mandando ele em branco
 * ---------------------------------------------------------------------------
 * `fill()` transforma `""` em `null` num campo nullable, entao um cliente que
 * mandasse `{"zoho_id_unidade": ""}` — o estado natural de um `<select>` sem
 * nada escolhido — dispararia a carga INTEIRA por acidente. Aqui isso e
 * RECUSADO: o campo presente exige um id de verdade, e a operacao longa e a que
 * precisa ser pedida explicitamente, pela ausencia do campo.
 *
 * E a mesma classe de decisao do `strictJsonTypes()` do irmao
 * `Migration_MigrarColaboradorInput`: nao coagir, nao adivinhar, recusar na
 * borda — que e o unico lugar onde ainda da para consertar. So que aqui o custo
 * do palpite errado nao e um registro errado, e ~700 chamadas ao Cognito que
 * ninguem pediu.
 */
import { registerContract } from './validate'

export interface Migration_MigrarColaboradoresInput {
zoho_id_unidade?: string
data_ini?: string
data_fim?: string
ids?: string
}

registerContract('Migration_MigrarColaboradoresInput', {
  zoho_id_unidade: { type: 'string',  required: false },
  data_ini:        { type: 'string',  required: false },
  data_fim:        { type: 'string',  required: false },
  ids:             { type: 'string',  required: false },
})
